import * as Yup from 'yup';

export   const  formValues={
    id:0,
    name:"",
    username:"",
    email:"",
    phoneNo:"",
    place:"",
    createdDate:"",
    activated:"",
    status:"",
    designation:"",
    districtID:1,
    talukID:1,
    regnlID:1,
    validationFrom:"",
    validationTO:"",
    roles:""
          }


export const validation = () => (
    
            Yup.object({
                
                heading:Yup.string()
                .required('Sorry the title is required'),
                content:Yup.string()
                .required('Sorry the content is required')
                .min(50,'That is it ? ...write some more'),
                // languageType:Yup.string()
                // .label('District')
                // .required("This field is requried"),
                //  phNo:Yup.string()
                //     .length(10)
                //     .matches(/^[0-9]{10}/)
                //     .required()
                //     .label('phone number').required("This field is phone number"),
                //     distcId:Yup.string()
                //     .label('District')
                //     .required("This field is requried"),
                //     talukId:Yup.string()
                //     .label('Taluk')
                //     .required("This field is requried")
            })
        )